import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IHemoTechChange } from 'app/models/licenses/hemo-tech/hemo-tech-change';

@Injectable({providedIn: 'root'})
export class HemoTechChangeService {
  private readonly api: string = environment.privateApi + 'HemoTechChange/';

  private http = inject(HttpClient);

  getChanges(licenseId: number): Observable<IHemoTechChange[]> {
    return this.http.get<IHemoTechChange[]>(this.api + 'GetChanges/' + licenseId);
  }

  createChange(licenseId: number): Observable<IHemoTechChange> {
    return this.http.post<IHemoTechChange>(this.api + 'CreateChange/' + licenseId, null);
  }

  updateChange(change: IHemoTechChange): Observable<IHemoTechChange> {
    return this.http.post<IHemoTechChange>(this.api + 'UpdateChange', change);
  }

  deleteChange(changeId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteChange/' + changeId);
  }

}
